import * as z from "zod"

export const GoogleClassroomPostTypeSchema = z.enum([
  "ASSIGNMENT",
  "SHORT_ANSWER_QUESTION",
  "MULTIPLE_CHOICE_QUESTION",
  "MATERIAL",
  "ANNOUNCEMENT",
])
export type GoogleClassroomPostType = z.output<typeof GoogleClassroomPostTypeSchema>

export const ExtraPostPropertiesSchema = z.object({
  topicName: z.string().nullable().optional(),
  choices: z.array(z.string()).nullable().optional(),
})

export const GOOGLE_CLASSROOM_POST_TYPES: ReadonlyArray<{
  postType: GoogleClassroomPostType
  label: string
}> = [
  { postType: "ASSIGNMENT", label: "Assignment" },
  { postType: "SHORT_ANSWER_QUESTION", label: "Short Answer Question" },
  { postType: "MULTIPLE_CHOICE_QUESTION", label: "Multiple Choice Question" },
  { postType: "MATERIAL", label: "Material" },
  { postType: "ANNOUNCEMENT", label: "Announcement" },
]
